import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["modal", "form", "actionInput", "title", "rejectionReason", "comment", "rejectionReasonError", "commentError", "stageInput","rejectionAndReturnBox"]

  connect() {
    this.modal = this.modalTarget;
  }

  open(event) {
    event.preventDefault();
    const projectId = event.currentTarget.dataset.projectId;
    const projectTitle = event.currentTarget.dataset.projectTitle;
    const stage = event.currentTarget.dataset.stage;

    this.formTarget.action = `/campus/student_projects/${projectId}/curate`;
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = projectTitle;
    }
    if (this.hasStageInputTarget) {
      this.stageInputTarget.value = stage;
    }

    if (this.hasRejectionAndReturnBoxTarget) {
      if (stage === 'open_submissions') {
        this.rejectionAndReturnBoxTarget.classList.remove('afd-hide');
      } else {
        this.rejectionAndReturnBoxTarget.classList.add('afd-hide');
      }
    }

    // Clear fields and errors on open
    if (this.hasRejectionReasonTarget) this.rejectionReasonTarget.value = "";
    if (this.hasCommentTarget) this.commentTarget.value = "";

    this.clearErrors();

    this.modal.open();
  }

  close(event) {
    event.preventDefault();
    this.modal.close();
  }

  submit(event) {
    const action = event.currentTarget.dataset.curationAction;
    this.clearErrors();

    if (action === 'reject_and_return') {
      let isValid = true;

      // Validate Rejection Reason
      if (this.hasRejectionReasonTarget && !this.rejectionReasonTarget.value) {
         if (this.hasRejectionReasonErrorTarget) this.rejectionReasonErrorTarget.classList.remove('afd-hide');
         isValid = false;
      }

      // Validate Comment
      if (this.hasCommentTarget && !this.commentTarget.value.trim()) {
         if (this.hasCommentErrorTarget) this.commentErrorTarget.style.display = 'block';
         isValid = false;
      }

      if (!isValid) return;
    }

    this.actionInputTarget.value = action;
    if (this.hasStageInputTarget) {
      this.stageInputTarget.value = this.stageInputTarget.value;
    }
    this.formTarget.submit();
  }

  clearErrors() {
    if (this.hasRejectionReasonErrorTarget) this.rejectionReasonErrorTarget.style.display = 'none';
    if (this.hasCommentErrorTarget) this.commentErrorTarget.style.display = 'none';
  }
}
